import React from 'react';
import { useCookies } from 'react-cookie';
import { useMatch } from 'react-router';
import ProjectIdContext from '.';
import useCardPreload from './Hooks/useCardPreload';

export default function ProjectIdContextProvider({ children }: { children: React.ReactNode }) {
  const [cookies, setCookies, clearCookies] = useCookies(['current-project']);
  const [projectId, setProjectId] = React.useState<string | null>(cookies['current-project'] ?? null);

  function updateProjectId(newValue: string | null) {
    if (newValue === null) clearCookies('current-project', { path: '/' });
    else {
      setCookies(
        'current-project',
        newValue,
        {
          path: '/', maxAge: 60 * 60 * 24 * 365, secure: true, sameSite: 'strict',
        },
      );
    }
    setProjectId(newValue);
  }

  let currentProjectId;
  const cardPathMatch = useMatch('/projects/:projectId/cards/:cardId');
  const decisionTreePathMatch = useMatch('/projects/:projectId/decision-trees/:decisionTreeId');

  if (cardPathMatch?.params.projectId) {
    currentProjectId = cardPathMatch.params.projectId;
  }

  if (decisionTreePathMatch?.params.projectId) {
    currentProjectId = decisionTreePathMatch.params.projectId;
  }

  const value = React.useMemo(() => ({
    projectId: projectId ?? currentProjectId,
    setProjectId: updateProjectId,
  }), [projectId, currentProjectId]);

  useCardPreload(projectId);

  return (
    <ProjectIdContext.Provider value={value}>
      {children}
    </ProjectIdContext.Provider>
  );
}
